import React from 'react';
import PropTypes from 'prop-types';
import { IconCondition } from 'svgIcons/MotionPortalIcons';

const TrendCommentsModalFieldError = ({ message, withIcon }) => {
    if (!message) {
        return null;
    }
    return (
        <div className='error-message text-danger small mt-1'>
            {message}
            {withIcon &&
                <div className={'error-icon'}>
                    <IconCondition condition={3} />
                </div>
            }
        </div>
    );
};

TrendCommentsModalFieldError.propTypes = {
    message: PropTypes.string,
    withIcon: PropTypes.bool
};

export default TrendCommentsModalFieldError;
